if (typeof Things == 'undefined') Things = {
    contextRoot: '/things',
};
"use strict";

Things.Device = Backbone.Model.extend({
    urlRoot: Things.contextRoot + '/device',
    TELTONIKA_REPORT_PRODUCT_IDS: ['TFT100', 'FMC230', 'FMC920'],

    defaults: function() {
    },

    copyFromProduct: function(product) {
        var attributes = {};
        attributes.productId = product.id;
        if (product.get('defaultConfiguration')) {
            attributes.configuration = this.get('configuration') || {};
            for (var key in product.get('defaultConfiguration')) {
                if (! (key in attributes.configuration)) attributes.configuration[key] = product.get('defaultConfiguration')[key];
            }
        }
        if (!this.get('smsPassword')) attributes.smsPassword = product.get('defaultSmsPassword');
        if (!this.get('reportInterval')) attributes.reportInterval = product.get('defaultReportInterval');
        attributes.make = attributes.model = null;
        this.set(attributes,{silent: true});
    },

    isEditable: function() {
        if (!Core.client.me.id) return false;
        if (this.get('deleted')) return false;
        return this.isNew() || Core.client.hasPermission('edit_all_data') || this.get('creatorUuid') == Core.client.me.get('uuid') || Core.client.hasGroupPermission(this.get('groupUuid'), 'admin_devices');
    },

    postData: function(data, options, serieName) {
        if (typeof options == 'string' && typeof serieName == 'undefined') {
            serieName = options;
            options = undefined;
        }
        return $.ajax({
            type: 'POST',
            url: this.url() + '/data' + (serieName ? '/' + serieName : '') + (options ? '?' + $.param(options) : ''),
            data: JSON.stringify(data),
            contentType: 'application/json'
        });
    },

    postEvent: function(event, options) {
        return $.ajax({
            type: 'POST',
            url: this.url() + '/event' + (options ? '?' + $.param(options) : ''),
            data: JSON.stringify(event),
            contentType: 'application/json'
        });
    },

    postLocation: function(location, options) {
        var self = this;
        return $.ajax({
            type: 'POST',
            url: this.url() + '/location' + (options ? '?' + $.param(options) : ''),
            data: JSON.stringify(location),
            contentType: 'application/json'
        }).success(function (response) {
            self.set('location', location);
        });
    },

    postCommand: function(command, options) {
        if (typeof command == 'string') {
            return $.ajax({
                type: 'POST',
                url: this.url() + '/command' + (options ? '?' + $.param(options) : ''),
                data: command,
                contentType: 'text/plain'
            });
        } else {
            return $.ajax({
                type: 'POST',
                url: this.url() + '/command' + (options ? '?' + $.param(options) : ''),
                data: JSON.stringify(command),
                contentType: 'application/json'
            });
        }
    },

    fetchData: function(options, serieName) {
        if (typeof options == 'string' && typeof serieName == 'undefined') {
            serieName = options;
            options = undefined;
        }
        return $.getJSON(this.url() + '/data' + (serieName ? '/' + serieName : '') + (options ? '?' + $.param(options) : ''));
    },

    fetchEvents: function(options) {
        return $.getJSON(this.url() + '/event' + (options ? '?' + $.param(options) : ''));
    },

    fetchLocations: function(options) {
        return $.getJSON(this.url() + '/location' + (options ? '?' + $.param(options) : ''));
    },

    fetchCommands: function(options) {
        return $.getJSON(this.url() + '/command' + (options ? '?' + $.param(options) : ''));
    },

    isTeltonikaReportable: function() {
        return this.get('productId') && this.TELTONIKA_REPORT_PRODUCT_IDS.includes(this.get('productId'))
    },
    isTeltonikaProduct: function(productId) {
        return this.TELTONIKA_REPORT_PRODUCT_IDS.includes(productId)
    }
});

Things.Devices = Backbone.Collection.extend({
    model: Things.Device,
    url: function() {
        if (this.path)
            return Things.contextRoot + '/device/' + this.path;
        else if (this.groupUuid)
            return Things.contextRoot + '/device/group/' + this.groupUuid;
        else
            return Things.contextRoot + '/device';
    },
    initialize: function(models, options) {
        if (options && options.groupUuid) this.groupUuid = options.groupUuid;
    }
});

Things.Devices.filterCollection = function(filter, collection) {
    var filteredCollection = new Things.Devices(collection.models);
    if (collection.searchQuery) return filteredCollection;
    if (filter) {
        if (filter.groups) {
            var groups = Core.client.groups.filter(function(group) {
                return filter.groups == group.id || $.isArray(filter.groups) && filter.groups.includes(group.id);
            });
            filteredCollection = new Things.Devices(filteredCollection.filter(function (device) {
                return groups.uuid === device.get('groupUuid') || ($.isArray(groups) && groups.find(function(group) { return group.get('uuid') === device.get('groupUuid'); }));
            }));
        } else {
            var activeGroupIds = Core.client.me.getActiveGroupMembershipIds();
            var groups = Core.client.groups.filter(function(group) {
                return activeGroupIds == group.id || $.isArray(activeGroupIds) && activeGroupIds.includes(group.id);
            });
            filteredCollection = new Things.Devices(filteredCollection.filter(function (device) {
                return groups.uuid === device.get('groupUuid') || ($.isArray(groups) && groups.find(function(group) { return group.get('uuid') === device.get('groupUuid'); }));
            }));
        }
    }
    return filteredCollection;
};